module.exports = __webpack_public_path__ + "img/dashboard.3e160aa.svg";